import ComingSoonHeader from "../ComingSoonHeader";
import Container from "../Container";
import React from "react";
import ScheduleWidget from "../ScheduleWidget";
import SubscriptionForm from "../SubscriptionForm/SubscriptionForm";
import getTime from "../../helpers/getTime";

export interface ComingSoonProps {
  pageName: string;
}

const ComingSoon = ({ pageName }: ComingSoonProps) => {
  return (
    <Container>
      <div className="lg:flex">
        <div className="w-full">
          <ComingSoonHeader header={pageName} />
          <div className="max-w-md">
            <SubscriptionForm
              title="Sign up to be notified about the event."
              buttonName="Notify Me"
            />
          </div>
        </div>
        {getTime() > getTime("28 Nov 2020") ? null : (
          <div className="w-full">
            <ScheduleWidget />
          </div>
        )}
      </div>
    </Container>
  );
};

export default ComingSoon;
